/**
 * TableStore - сховище для управління станом таблиці
 * 
 * Розширює UIManager і забезпечує керування станом таблиці через MobX
 */

import { UIManager } from '@/Core/Managers/UI/UIManager'
import type { IUIManagerConfig } from '@/Core/Contracts/UI/UIManager'

interface TableStoreConfig extends IUIManagerConfig {

}

export class TableStore extends UIManager {
    constructor({
        ...props
    }: TableStoreConfig = {}) {

        props.contextKey = 'tableContext'
        
        super(props)
    }
}
